import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { NavLink } from "react-router-dom";
import { formatDecimalNumber } from "../../../utils/format";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";

import { StyledBreakWord } from "../../styles/styledBreakWord";
import { StyledCopy } from "../../styles/styledCopy";
import { StyledCol, StyledTableRow } from "../../styles/styledTable";

const MasterRefillingsItem = ({ t, value, setNotification }) => {

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <StyledTableRow
      scroll="auto"
      col="6"
      onClick={(e) => {showDetails(e);}}
      cursor="pointer"
      data-action="details"
      className="master-refilling-table__row"
      as={NavLink}
      to={`/master-refillings/${value.id}`}
    >
      <StyledCol inline data-action="details">
        <StyledBreakWord as="p">
          {formatDecimalNumber(value.amount)} {value.masterBalance.currency.asset}
        </StyledBreakWord>
      </StyledCol>
      <StyledCol data-action="details">
        {getServiceNameWithNickname(value.masterBalance.service.name, value.masterBalance.service.nickname)}
      </StyledCol>
      <StyledCol data-action="details">
        {value.type}
      </StyledCol>
      <StyledCol data-action="details" inline>
        <StyledBreakWord as="p">
          {value.user.email}
        </StyledBreakWord>
      </StyledCol>
      <StyledCol data-action="details">
        {TimestampToDateMoment(value.createdAt)}
      </StyledCol>
      <StyledCol data-action="details">
        <CopyToClipboard
          className="stop-event"
          text={value.id}
          onCopy={() => {
            setNotification((prev) => ({
              ...prev,
              visible: true,
              type: "success",
              message: t("table.copied")
            }));
          }}
        >
          <StyledBreakWord as="p">
            {value.id} <StyledCopy
            title={t("table.copy")}
            className="icon-light-copy"
          />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
    </StyledTableRow>
  );
};

export default MasterRefillingsItem;